import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationService } from '@fuse/services/confirmation/confirmation.service';
import { FuseConfirmationDialogComponent } from '@fuse/services/confirmation/dialog/dialog.component';
import { CommonModule } from '@angular/common';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [FuseConfirmationDialogComponent],
  imports: [MatButtonModule, DynamicDialogModule, MatIconModule, CommonModule],
  providers: [FuseConfirmationService, DialogService],
})
export class FuseConfirmationModule {
  /**
   * Constructor
   */
  constructor(private _fuseConfirmationService: FuseConfirmationService) {}
}
